import React from 'react';
import { WixDesignSystemsMaskingContext } from '../../index';
import { render } from '@testing-library/react';
import { WixDesignSystemsMaskingProvider } from '../WixDesignSystemsMaskingProvider';
import { maskingClassNames as maskingClasses } from '../constants';

describe('WixDesignSystemsMaskingContext', () => {
  it('should provide masking classNames trough its context', async () => {
    const { container } = render(
      <WixDesignSystemsMaskingProvider>
        <WixDesignSystemsMaskingContext.Consumer>
          {({ maskingClassNames }) => (
            <div
              data-hook="masked-component"
              data-mask={maskingClassNames}
            ></div>
          )}
        </WixDesignSystemsMaskingContext.Consumer>
      </WixDesignSystemsMaskingProvider>,
    );

    expect(
      container
        .querySelector(`[data-hook="masked-component"]`)
        ?.getAttribute('data-mask'),
    ).toBe(maskingClasses);
  });
});
